import { ContentType, Filter, Sort } from '@/swagger/constants/contents-orchestrator-enums';

export const it = {
  trainingSoftSkills: {
    pageTitle: 'Training',
    trainingSoftSkillsTitleEmployee: 'Migliora le tue soft skills',
    trainingSoftSkillsTitleAdmin: 'Formazione e crescita delle soft skills',
    description:
      'Esplora guide, video corsi e quiz pensati per aiutare i tuoi dipendenti a sviluppare le soft skills più richieste dal mercato.\nPer ogni contenuto puoi anche vedere quante volte è stato visualizzato e quale valutazione media ha ricevuto dagli utenti, così da avere un’idea immediata della sua rilevanza.',
    cards: {
      VIDEO: {
        start: 'Guarda ora',
        resume: 'Continua a guardare',
        restart: 'Rivedi video',
        duration: '{{time}} min',
      },
      DOCUMENT: {
        start: 'Visualizza',
        resume: 'Riprendi',
        restart: 'Rivedi documento',
        duration: 'Tempo di lettura: {{time}} minuti',
      },
      QUIZ: {
        start: 'Inizia',
        resume: 'Riprendi',
        restart: 'Ricomincia',
        questions: '{{questions}} Domande',
        duration: '{{time}} min',
        progress: 'Domande: {{current}}/{{total}}',
      },
      GENERIC: {
        completed: 'Completato',
        inProgress: 'In corso',
        newVersion: 'Nuova versione',
        credits: '{{credits}} Crediti',
        skillToBoost: 'Skill to boost',
      },
    },
    sections: {
      newContents: {
        title: 'Novità',
        subTitle: 'Visualizza le ultime novità di contenuti',
      },
      myContents: {
        title: 'I tuoi contenuti',
        subTitle: 'Ritrova i contenuti salvati, in corso o completati',
        showAll: 'Mostra tutti',
      },
      contentsInProgress: {
        title: 'Continua i tuoi corsi',
        [ContentType.VIDEO]: 'Continua i tuoi video',
        [ContentType.PDF]: 'Continua i tuoi PDF',
        [ContentType.QUIZ]: 'Continua i tuoi quiz',
      },
      mainContents: {
        title: 'Tutti i corsi',
        titleVideo: 'Contenuti video',
        titleDocuments: 'Documenti utili',
        titleQuizzes: {
          admin: 'Quiz',
          learning: 'Mettiti alla prova',
        },
        descriptionQuizzes:
          'Verifica quanto hai imparato con i nostri quiz dedicati alle soft skills. Ogni tentativo ti propone 10 domande diverse, scelte casualmente, per aiutarti a consolidare le tue conoscenze e monitorare i tuoi progressi.',
        showAll: 'Mostra tutti',
        noContent: 'Nessun contenuto disponibile',
      },
      paginatedContents: {
        title: {
          saved: 'I tuoi corsi',
          [ContentType.VIDEO]: 'Tutti i video',
          [ContentType.PDF]: 'Tutti i PDF',
          [ContentType.QUIZ]: 'Tutti i quiz',
        },
      },
    },
    filtersAndOrderContent: {
      filter: 'Filtra',
      orderBy: 'Ordina per',
      search: 'Cerca',
      discard: 'Annulla',
      apply: 'Salva',
      orders: {
        sortBy: {
          [Sort.MOSTRECENT]: 'Più recenti',
          [Sort.HIGHESTRATING]: 'Valutazione più alta',
        },
      },
      filters: {
        type: {
          placeHolder: 'Formato',
          [ContentType.VIDEO]: 'Video',
          [ContentType.PDF]: 'PDF',
          [ContentType.QUIZ]: 'Quiz',
        },
        state: {
          placeHolder: 'Stato',
          [Filter.ISCOMPLETED]: 'Completati',
          [Filter.ISSAVED]: 'Salvati',
        },
      },
      tags: {
        all: 'Tutti',
      },
    },
    emptyState: {
      noContents: 'Al momento non sono disponibili contenuti. Ti invitiamo a riprovare più tardi.',
    },
    tutorial: {
      learning: {
        title: 'Scopri il training sulle Soft skills',
        close: 'Chiudi',
        next: 'Avanti',
        previous: 'Indietro',
        goToGuide: 'Vai alla guida',
        slides: {
          slide1: {
            title: 'Esplora i contenuti e mettiti alla prova',
            description:
              'Sfoglia i contenuti disponibili nel catalogo e metti alla prova le tue conoscenze. Troverai i contenuti relativi alle skills con margine di crescita contrassegnati dal tag "Skill to Boost".',
          },
          slide2: {
            title: 'I tuoi contenuti',
            description:
              'Nella sezione "I tuoi contenuti" puoi tenere traccia di ciò che hai salvato, completato e che è ancora in corso. Lascia i tuoi feedback sui contenuti per aiutare gli altri ad orientarsi.',
          },
        },
      },
      admin: {
        title: 'Scopri il training sulle Soft skills',
        close: 'Chiudi',
        next: 'Avanti',
        previous: 'Indietro',
        goToGuide: 'Vai alla guida',
        slides: {
          slide1: {
            title: 'Ricerca rapida e dati essenziali',
            description:
              "Visualizza l'elenco di tutti i contenuti disponibili. Utilizza i filtri per categoria e la barra di ricerca per trovare i materiali desiderati e visualizzare dati chiave come la valutazione media e la durata.",
          },
          slide2: {
            title: 'Anteprima completa dei contenuti',
            description:
              "In qualità di Admin hai la possibilità di visionare tutti i materiali disponibili nel catalogo per valutarne il valore formativo per le tue persone. In base ai risultati dell'assessment, la piattaforma contrassegna con il tag \"Skill to boost\" i contenuti legati alle skills meno sviluppate all'interno dell'intera organizzazione.",
          },
          slide3: {
            title: 'Esplora tutti i contenuti',
            description:
              "Scopri l'intero catalogo formativo della piattaforma: trovi video, materiali e quiz suddivisi per tipologia per una navigazione semplice e immediata.",
          },
        },
      },
    },
  },
};
